
import React, { useEffect } from 'react';

export interface ToastType {
  id: string;
  type: 'success' | 'error' | 'info';
  message: string;
}

interface ToastProps {
  toasts: ToastType[];
  onRemove: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ toasts, onRemove }) => {
  return (
    <div className="fixed top-6 right-6 z-[400] flex flex-col gap-3 w-full max-w-xs pointer-events-none">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onRemove={onRemove} />
      ))}
    </div>
  );
};

const ToastItem: React.FC<{ toast: ToastType; onRemove: (id: string) => void }> = ({ toast, onRemove }) => {
  useEffect(() => {
    const timer = setTimeout(() => onRemove(toast.id), 5000);
    return () => clearTimeout(timer);
  }, [toast.id, onRemove]);

  const styles = {
    success: {
      bg: 'bg-emerald-500',
      icon: 'fa-check-circle'
    },
    error: {
      bg: 'bg-rose-500',
      icon: 'fa-circle-exclamation'
    },
    info: {
      bg: 'bg-blue-500',
      icon: 'fa-circle-info'
    }
  };

  const current = styles[toast.type];

  return (
    <div className={`
      pointer-events-auto flex items-center gap-3 p-4 rounded-2xl shadow-2xl shadow-black/20 
      ${current.bg} text-white animate-in slide-in-from-right-10 fade-in duration-500
    `}>
      <div className="w-8 h-8 rounded-xl bg-white/20 flex items-center justify-center shrink-0">
        <i className={`fas ${current.icon} text-sm`}></i>
      </div>
      <p className="text-[12px] font-black leading-tight flex-1">{toast.message}</p>
      <button onClick={() => onRemove(toast.id)} className="p-1 hover:bg-white/10 rounded-lg transition-colors">
        <i className="fas fa-times text-xs opacity-70"></i>
      </button>
    </div>
  );
};

export default Toast;
